// src/components/ArticleList.js

import React from "react";
import { Link } from "react-router-dom";

const articles = [
  {
    id: 1,
    title: "Understanding the Vouch System",
    slug: "understanding-vouch-system",
  },
];

const ArticleList = () => {
  return (
    <div className="article-list p-8">
      <h3 className="text-2xl font-semibold mb-4">Articles</h3>
      <ul>
        {articles.map((article) => (
          <li key={article.id}>
            <Link to={`/article/${article.slug}`}>{article.title}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ArticleList;
